import { reporter } from '@/lib/reporter'
import React, { Component, ReactNode } from 'react'

type ErrorBoundaryProps = {
  children: ReactNode
  onError: () => void
}

type ErrorBoundaryState = {
  hasError: boolean
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Error caught in ErrorBoundary: ', error, errorInfo)

    // Report React component errors to Sentry
    const reactError = new Error(`React Component Error: ${error.message}`)
    ;(reactError as any).componentStack = errorInfo.componentStack
    ;(reactError as any).originalError = error
    reporter.capture(reactError)

    this.props.onError()
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>
    }

    return this.props.children
  }
}

export default ErrorBoundary
